import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Footer styled component
export const FooterContainer = styled(Box)({
  backgroundColor: 'rgb(10, 4, 22)',
  paddingTop: '10px',
  paddingBottom: '8px',
  bottom: 0,
});

// Navbar brand
export const NavbarBrand = styled(Typography)({
  color: 'rgb(250, 250, 250) !important',
});

// Logo
export const Logo = styled('img')({
  height: '2.5em !important',
  width: '2.5em !important',
});
